<template>
  <div class="container">
    <v-suburb v-show="ifSuburb" @change="changeSuburb" @close="suburbClose()"></v-suburb>
    <div class="main" v-show="!ifSuburb">
        <div class="navi">
            <span class="close"><span class="icon-arrow-left" @click="goBack()"></span></span>
            <div class="top-title">接送机服务</div>
            <span></span>
        </div>
        <div class="logo"><img src="../../../assets/img/index/logohf.svg"></div>
        <div class="core">
            <h2>预定接送机</h2>
            <div class="notice-box" v-show="ifHoliday()">
                <div class="notice-yellow">
                    {{holidayWord()}}
                </div>
            </div>
            <div v-show="nextStep">
                <div class="weui-cells__title">联系信息</div>
                <div class="weui-cells weui-cells_form">
                    <div class="weui-cell">
                        <div class="weui-cell__hd"><label class="weui-label">联系人</label></div>
                        <div class="weui-cell__bd">
                            <input class="weui-input" type="text" placeholder="请输入您的名字" v-model="data.username">
                        </div>
                    </div>
                    <div class="weui-cell">
                        <div class="weui-cell__hd">
                            <label class="weui-label">联系手机</label>
                        </div>
                        <div class="weui-cell__bd">
                            <input class="weui-input" type="tel" placeholder="请输入您的手机号" v-model="data.userphone">
                        </div>
                    </div>
                </div>
                <div class="notice-yellow form">
                最后一步，请填写联系信息，我们客服收到后会尽快给您电话回访确认服务细节
                </div>
            </div>
            <div v-show="!nextStep">
                <div class="weui-cells__title">服务类型</div>
                <div class="weui-cells weui-cells_checkbox">
                    <label class="weui-cell weui-check__label" for="s11" >
                        <div class="weui-cell__hd">
                            <input type="radio" class="weui-check" name="checkbox1" id="s11" value="1" v-model="data.service" >
                            <i class="weui-icon-checked"></i>
                        </div>
                        <div class="weui-cell__bd">
                            <p>接机服务</p>
                        </div>
                    </label>
                    <label class="weui-cell weui-check__label" for="s12">
                        <div class="weui-cell__hd">
                            <input type="radio" name="checkbox1" class="weui-check" id="s12" value="2" v-model="data.service" >
                            <i class="weui-icon-checked"></i>
                        </div>
                        <div class="weui-cell__bd">
                            <p>送机服务</p>
                        </div>
                    </label>
                </div>
                <div class="weui-cells__title">机场信息</div>
                <div class="weui-cells weui-cells_form weui-cells_checkbox">
                    <div class="weui-cell">
                        <div class="weui-cell__bd">
                            <p>悉尼金斯福德 · 史密斯国际机场</p>
                        </div>
                    </div>

                    <label class="weui-cell weui-check__label" for="s14">
                        <div class="weui-cell__hd">
                            <input type="radio" name="checkbox2" class="weui-check" id="s14" value="2" v-model="data.terminal"  >
                            <i class="weui-icon-checked"></i>
                        </div>
                        <div class="weui-cell__bd">
                            <p>国际 International Airport</p>
                        </div>
                    </label>
                    <label class="weui-cell weui-check__label" for="s13" >
                        <div class="weui-cell__hd">
                            <input type="radio" class="weui-check" name="checkbox2" id="s13" value="1" v-model="data.terminal" >
                            <i class="weui-icon-checked"></i>
                        </div>
                        <div class="weui-cell__bd">
                            <p>国内 Domesitc Airport</p>
                        </div>
                    </label>
                </div>
                <div class="weui-cells__title">{{ data.service==0 ? '服务信息' : '' }} {{ data.service==1 ? '接机信息' : '' }} {{ data.service==2 ? '送机信息' : '' }}</div>
                <div class="weui-cells weui-cells_form">
                    <div class="weui-cell">
                        <div class="weui-cell__hd"><label class="weui-label">航班号</label></div>
                        <div class="weui-cell__bd">
                            <input class="weui-input" type="text" placeholder="请填写航班号，如CZ301"  v-model="data.flight">
                        </div>
                    </div>
                    <div class="weui-cell">
                        <div class="weui-cell__hd"><label for="" class="weui-label">{{ data.service==0 ? '服务日期' : '' }} {{ data.service==1 ? '接机日期' : '' }} {{ data.service==2 ? '送机日期' : '' }}</label></div>
                        <div class="weui-cell__bd">
                            <input class="weui-input" type="date" value="" v-model="data.service_date" :min="dateToday()">
                        </div>
                    </div>
                    <div class="weui-cell">
                        <div class="weui-cell__hd"><label for="" class="weui-label"> {{ data.service==0 ? '服务时间' : '' }} {{ data.service==1 ? '接机时间' : '' }} {{ data.service==2 ? '送机时间' : '' }}</label></div>
                        <div class="weui-cell__bd">
                            <input class="weui-input" type="time" value="" v-model="data.arrival_time" >
                        </div>
                    </div>
                    <div class="weui-cell">
                        <div class="weui-cell__hd"><label class="weui-label">总人数</label></div>
                        <div class="weui-cell__bd">
                            <input class="weui-input" type="number" min="1" max="10" placeholder="请填写同行的总人数" v-model="data.passenger">
                        </div>
                    </div>
                    <div class="weui-cell weui-cell_select weui-cell_select-after">
                        <div class="weui-cell__hd">
                            <label for="" class="weui-label">婴儿座椅</label>
                        </div>
                        <div class="weui-cell__bd">
                            <select class="weui-select" name="select2" v-model="data.babyseat">
                                <option value="1" selected >不需要</option>
                                <option value="2">需要</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="weui-cells__title">地址详情</div>
                <div class="weui-cells weui-cells_form" >
                    <div class="weui-cell" v-show="data.service!=0">
                        <div class="weui-cell__bd">
                            <p>{{ data.service==1 ? '🚐接机后送您去哪里？' : '' }} {{ data.service==2 ? '🚐您要在哪里上车？' : '' }}</p>
                        </div>
                    </div>
                    <div class="weui-cell">
                        <div class="weui-cell__hd"><label class="weui-label">Street</label></div>
                        <div class="weui-cell__bd">
                            <input class="weui-input" type="text" placeholder="如：Unit 2, 9 Hunter St" v-model="data.address_street">
                        </div>
                    </div>
                    <div class="weui-cell weui-cell_access padding-fix"  @click="suburbSelect()">
                        <div class="weui-cell__hd">
                            <label class="weui-label">Suburb</label>
                        </div>
                        <div class="weui-cell__bd" v-if="data.address_suburb==''"> 
                            <p class="placeholder-color">如：Chatswood</p>
                        </div>
                        <div class="weui-cell__bd" v-if="data.address_suburb!=''"> 
                            <p>{{data.address_suburb}}</p>
                        </div>
                        <div class="weui-cell__ft"></div>
                    </div>
                    <div class="weui-cell weui-cell_select weui-cell_select-after">
                        <div class="weui-cell__hd"><label class="weui-label">State</label></div>
                        <div class="weui-cell__bd">
                            <select class="weui-select" name="select2" >
                                <option value="NSW" selected>NSW</option>
                            </select>
                        </div>
                    </div>
                    <div class="weui-cell" >
                        <div class="weui-cell__hd"><label class="weui-label">Postcode</label></div>
                        <div class="weui-cell__bd">
                            <input class="weui-input" type="text" v-model="data.address_postcode" placeholder="如：2000">
                        </div>
                    </div>
                </div>
                <div class="weui-cells__title">留言备注</div>
                <div class="weui-cells weui-cells_form">
                    <div class="weui-cell">
                        <div class="weui-cell__bd">
                            <textarea class="weui-textarea" placeholder="告诉我们更多需求，我们将给您提供更周到的服务" rows="3" v-model="data.message"></textarea>
                        </div>
                    </div>
                </div>
            </div>
            <br>
        </div>
        <div class="btn-box-fix">
            <div class="btn-container">
                <div class="btn active" @click="submitOrder()">立即下单</div>
            </div>
        </div>
    </div>
    <div v-show="localErrorShow">
        <div class="weui-mask"></div>
        <div class="weui-dialog">
            <div class="weui-dialog__bd">{{localError[0]}}</div>
            <div class="weui-dialog__ft">
                <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="localErrorShow=false">好的</a>
            </div>
        </div>
    </div>
    <transition name="fade">
        <div id="loadingToast" v-show="isSending">
            <div class="weui-mask_transparent"></div>
            <div class="weui-toast">
                <i class="weui-loading weui-icon_toast"></i>
                <p class="weui-toast__content">正在提交订单</p>
            </div>
        </div>
    </transition>
    <img :src="pixelURL('JieSongJi','xiadan')" class="hide">
  </div>
</template>

<script>
import qs from 'qs'
import anime from 'animejs';

export default {
  name: 'index',
  data () {
    return {
        data:{
            token:0,
            type_id:1550735966,
            username:"",
            userphone:"",
            address_street:"",
            address_suburb:"",
            address_postcode:"",
            address_state:"nsw",
            service:0,
            terminal:"",
            flight:"",
            service_date:"",
            arrival_time:"",
            passenger:"",
            flight:"",
            babyseat:1,
            message:""
        },
        isSending:false,
        nextStep:false,
        ifSuburb:false,
        localError:[],
        localErrorShow:false,
        rememberTop:0
    }
  },
  methods: {
    goBack: function() {
        if(this.nextStep){
            this.nextStep = false;
            return false;
        }
        if(this.$route.query.back){
            this.$router.go(-1);
        }
        else{
            this.$router.push('/');
        }
    },
    dateToday: function(){
        let today = new Date().toISOString().slice(0, 10);
        return today;
    },
    sleep (time) {
      return new Promise((resolve) => setTimeout(resolve, time));
    },
    suburbSelect: function() {
        this.rememberTop = window.scrollY;
        this.ifSuburb=true;
        document.querySelector("html").classList.remove("service-car-bg");
        document.querySelector("html").classList.add("grey-background");
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    },
    changeSuburb: function(suburb,postcode) {
        this.data.address_suburb = suburb;
        this.data.address_postcode = postcode;
        this.sleep(10).then(() => {
            document.documentElement.scrollTop = this.rememberTop;
            document.body.scrollTop = this.rememberTop;
        });
        document.querySelector("html").classList.remove("grey-background");
        document.querySelector("html").classList.add("service-car-bg");
        this.ifSuburb=false;

    },
    suburbClose: function() {
        this.sleep(10).then(() => {
            document.documentElement.scrollTop = this.rememberTop;
            document.body.scrollTop = this.rememberTop;
        });
        document.querySelector("html").classList.remove("grey-background");
        document.querySelector("html").classList.add("service-car-bg");
        this.ifSuburb=false;
    },
    submitOrder: function() {
        if(!this.nextStep){
            if(this.checkSubmit()){
                this.nextStep=true;
                return false;
            }
        }
        if(this.nextStep){
            if(this.checkSubmitPost()){
                this.submitOrderPost();
            }
        }
    },
    checkSubmit(){
        this.localError = [];
        if (!this.data.service) {
            this.localError.push("请选择服务类型（ 接机 / 送机 ）");
        }
        if (!this.data.terminal) {
            this.localError.push("请选择航站楼信息（ 国际 / 国内 ）");
        }
        if (!this.data.flight) {
            this.localError.push("请填写航班号");
        }
        if (!this.data.service_date) {
            this.localError.push("请填写服务日期");
        }
        if (!this.data.arrival_time) {
            this.localError.push("请填写服务时间");
        }
        if (!this.data.passenger) {
            this.localError.push("请填写同行总人数");
        }
        if (!this.data.address_street) {
            this.localError.push("请填写 Street 地址信息");
        } else if (this.data.address_street.length < 5) {
            this.localError.push("Street 地址长度过短，请检查是否正确");
        }
        if (!this.data.address_suburb) {
            this.localError.push("请选择地址栏 Suburb");
        }
        if (!this.data.address_postcode) {
            this.localError.push("请填写 Postcode 邮编");
        } else if (this.data.address_postcode.length != 4) {
            this.localError.push("请填写4位数字 Postcode 邮编号码");
        }
        if (!this.localError.length) {
          return true;
        }
        else{
          this.localErrorShow = true;
          return false;
        }
    },
    checkSubmitPost(){
        this.localError = [];
        if (!this.data.username) {
            this.localError.push("请填写联系人名");
        }
        if (!this.data.userphone) {
            this.localError.push("请填写联系人手机号");
        }
        if (this.data.userphone.length<8 || this.data.userphone.length>11) {
            this.localError.push("手机号码长度不正确，请检查是否正确");
        }
        if (!this.localError.length) {
          return true;
        }
        else{
          this.localErrorShow = true;
          return false;
        }
    },
    submitOrderPost(){
      if(this.isSending){
        return false;
      }
      else{
        this.isSending = true;
        let that = this;

        //做对象的副本出来
        let orderObject =  JSON.parse(JSON.stringify(this.data));

        if(this.checkLogin()){
            orderObject.token = localStorage.token;
        }
        else{
            orderObject.token = 0;
        }
        
        this.axios.post(this.apiURL()+'/Order/createTempOrder', qs.stringify(orderObject))
        .then(function (response) {
          if(response.data.error_code==0){
            that.$router.push('/order-form-success?id='+response.data.data.order_id);
          }
          else{
            alert("提交失败："+response.data.data)
            that.isSending=false;
          }
        })
        .catch(function (error) {
          alert("提交失败，请检查网络并重新尝试")
          that.isSending=false;
          console.log(error);
        });
      }
    },
  },
  created: function () {
    document.querySelector("html").classList.add("service-car-bg");
    if(this.data.username==""&&localStorage.member_name){
        this.data.username = localStorage.member_name;
    }
    if(this.data.userphone==""&&localStorage.member_phone){
        this.data.userphone = localStorage.member_phone;
    }
  },
  destroyed() {
    document.querySelector("html").classList.remove("service-car-bg");
  }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../../assets/css/base.scss";
.main{
    padding:0 10px;
}
.navi{
    display: flex;
    justify-content:space-between;
    padding:0 0 0 0;
    position:fixed;
    top:0;
    left:0;
    width:100%;
    background:rgba(255, 255, 255, 0.9);
    z-index:999;
    span{
        flex: 1;
    }
    div{
        flex:2;
    }
    .close{
        text-align:left;
        font-size:1em;
        .icon-arrow-left{
            margin-right:12px;
            margin-top:12px;
            display:inline-block;
        }
    }
    .icon-arrow-left{
        padding-left:12pt;
    }
    .top-title{
        font-size:0.5em;
        line-height:3.2em;
        color:#444;
        vertical-align:top;
        display:inline-block;
        text-align:center;
    }
}

.container{
  padding-bottom:60px;
}

.container /deep/ .weui-label{
    width:90px;
}

.core{
  background:#f6f6f6;
  border-radius:4px;
  h2{
    padding: 14px 14px 0 14px;
    text-align:center;
  }
}

.logo{
  margin:10vh 0 2vh 6vw;
  img{
    width:46%;
  }
}

.title-sub{
  color: #fff;
  font-size: 0.8em;
  text-align: left;
  margin-bottom:5vh;
}
.park-assist{
    text-align:center;
    color:#fe9567;
}

.container /deep/ .weui-cells_checkbox .weui-check:checked+.weui-icon-checked:before{
  color: #fe9567;
}

</style>



// WEBPACK FOOTER //
// src/pages/service/form/car.vue